import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import HomeLayout from '../layouts/home/Home';
import { StoreProvider, createAppState } from '../store/store';
var _window$appModel = window['appModel'],
  config = _window$appModel.config,
  branchenbuchSearch = _window$appModel.branchenbuchSearch,
  teaserData = _window$appModel.teaserData;
var preloadedState = createAppState({
  config: config,
  branchenbuchSearch: branchenbuchSearch,
  teaserData: teaserData
});
var container = document.getElementById('app');
if (container) {
  hydrateRoot(container, /*#__PURE__*/React.createElement(StoreProvider, {
    initialState: preloadedState
  }, /*#__PURE__*/React.createElement(HomeLayout, null)));
} else {
  console.error('Could not find DOM element with id "app"');
}